(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product"]) return;
  try {
    
    document.querySelectorAll('[data-product-gallery]').forEach(gallery => {
        const slides = Array.from(gallery.querySelectorAll('[data-gallery-slide]'));
        if (slides.length <= 1) {
            return;
        }

        const prevButton = gallery.querySelector('[data-gallery-prev]');
        const nextButton = gallery.querySelector('[data-gallery-next]');
        const counter = gallery.querySelector('[data-gallery-count]');
        let currentIndex = 0;
        let touchStartX = 0;

        const renderSlide = () => {
            slides.forEach((slide, index) => {
                slide.classList.toggle('is-active', index === currentIndex);
            });

            if (counter) {
                counter.textContent = `${currentIndex + 1} / ${slides.length}`;
            }
        };

        const goTo = nextIndex => {
            currentIndex = (nextIndex + slides.length) % slides.length;
            renderSlide();
        };

        if (prevButton) {
            prevButton.addEventListener('click', () => {
                goTo(currentIndex - 1);
            });
        }

        if (nextButton) {
            nextButton.addEventListener('click', () => {
                goTo(currentIndex + 1);
            });
        }

        gallery.addEventListener('touchstart', event => {
            touchStartX = event.changedTouches[0].clientX;
        });

        gallery.addEventListener('touchend', event => {
            const deltaX = event.changedTouches[0].clientX - touchStartX;

            if (Math.abs(deltaX) < 30) {
                return;
            }

            if (deltaX > 0) {
                goTo(currentIndex - 1);
                return;
            }

            goTo(currentIndex + 1);
        });

        renderSlide();
    });

    document.querySelectorAll('[data-product-form]').forEach(form => {
        const variantSelector = form.querySelector('[data-variant-id-selector]');
        const optionSelectors = form.querySelectorAll('[data-product-option]');
        const priceElement = form.querySelector('[data-product-price]');
        const quantityInput = form.querySelector('[data-quantity-input]');
        const quantityValue = form.querySelector('[data-quantity-value]');
        const decreaseButton = form.querySelector('[data-quantity-decrease]');
        const increaseButton = form.querySelector('[data-quantity-increase]');
        const addToCartButton = form.querySelector('.product-actions__btn--add-to-cart');
        const addToCartTextElement = form.querySelector('[data-add-to-cart-text]');

        /**
         * Syncs the hidden variant selector and displayed price based on
         * the selected option values (capacity, grind setting, etc.).
         *
         * When a user changes any product option select (e.g. capacity),
         * this function finds the matching variant and updates the price.
         */
        const syncVariantFromOptions = () => {
            if (!variantSelector || optionSelectors.length === 0) {
                return;
            }

            // Collect selected values from all option selects
            // e.g. { '1': '500g', '2': 'Whole Bean' }
            const selectedOptionValues = {};
            optionSelectors.forEach(select => {
                selectedOptionValues[select.dataset.productOption] = select.value;
            });

            // Find the variant that matches all selected options
            const matchingOption = Array.from(variantSelector.options).find(option => {
                const option1Match =
                    !selectedOptionValues['1'] ||
                    option.dataset.option1 === selectedOptionValues['1'];
                const option2Match =
                    !selectedOptionValues['2'] ||
                    option.dataset.option2 === selectedOptionValues['2'];
                const option3Match =
                    !selectedOptionValues['3'] ||
                    option.dataset.option3 === selectedOptionValues['3'];

                return option1Match && option2Match && option3Match;
            });

            if (!matchingOption) {
                return;
            }

            // Update hidden variant ID selector
            variantSelector.value = matchingOption.value;

            // Update displayed price with the matching variant's price
            if (priceElement && matchingOption.dataset.price) {
                priceElement.textContent = matchingOption.dataset.price;
            }
        };

        const setQuantity = nextValue => {
            const safeValue = Math.max(1, nextValue);
            if (quantityInput) {
                quantityInput.value = String(safeValue);
            }
            if (quantityValue) {
                quantityValue.textContent = String(safeValue);
            }
        };

        // Listen for changes on all option selects (capacity, grind setting, etc.)
        optionSelectors.forEach(select => {
            select.addEventListener('change', syncVariantFromOptions);
        });

        if (decreaseButton) {
            decreaseButton.addEventListener('click', () => {
                const currentQuantity = Number(quantityInput ? quantityInput.value : 1);
                setQuantity(currentQuantity - 1);
            });
        }

        if (increaseButton) {
            increaseButton.addEventListener('click', () => {
                const currentQuantity = Number(quantityInput ? quantityInput.value : 1);
                setQuantity(currentQuantity + 1);
            });
        }

        form.addEventListener('submit', async event => {
            const submitter = event.submitter;
            if (!submitter || !submitter.classList.contains('product-actions__btn--add-to-cart')) {
                return;
            }

            event.preventDefault();

            if (addToCartButton) {
                addToCartButton.disabled = true;
                if (addToCartTextElement) {
                    addToCartTextElement.textContent = 'Adding...';
                }
            }

            try {
                const response = await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                        Accept: 'application/json',
                    },
                    body: new FormData(form),
                });

                if (!response.ok) {
                    throw new Error('Add to cart failed');
                }

                document.dispatchEvent(new CustomEvent('mini-cart:open'));
            } catch (error) {
                console.error(error);
            } finally {
                if (addToCartButton) {
                    addToCartButton.disabled = false;
                }
                if (addToCartTextElement) {
                    addToCartTextElement.textContent = 'Add to cart';
                }
            }
        });

        // Initialize price on page load
        syncVariantFromOptions();
    });

  } catch(e) { console.error(e); }
})();
})();
